export default __webpack_public_path__ + "static/media/traffic-cone.d538b72f.png";